/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
  <div class>
    <membership-banner
      v-if="alt"
      :add_button="true"
      :styles="$store.getters['membership'].style"
      :label="$store.getters['membership'].label"
    ></membership-banner>

    <v-container class="py-0">
      <v-row justify="center">
        <v-col cols="12" lg="12" xl="9">
          <v-container class="pa-0">
            <v-row align="center" justify="center" class="mb-4">
              <v-col
                cols="10"
                sm="6"
                md="4"
                lg="3"
                xl="3"
                order="2"
                order-md="1"
              >
                <v-text-field
                  label="Search"
                  append-icon="fa-search"
                  hide-details
                  clearable
                  v-model="search"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="4"
                lg="6"
                xl="6"
                class="text-center"
                order="1"
                order-md="2"
              >
                <div class="d-flex justify-center align-center">
                  <h2 class="secondary--text">My Portals</h2>
                  <v-btn icon title="share" @click="sharePortals" class="ml-2">
                    <v-icon>fa-share-square</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col
                cols="10"
                sm="6"
                md="4"
                lg="3"
                xl="3"
                order="3"
                order-md="3"
              >
                <v-select
                  label="Sort by"
                  v-model="sort_by"
                  hide-details
                  :items="sort_options"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="py-12" align="center" v-if="!items.length">
              <v-col cols="12" class="text-center text--secondary">
                <h4>
                  Welcome, create your first portal to get started
                  <v-icon color="blue" @click="$eventBus.$emit('new-portal')"
                    >fa-plus-circle</v-icon
                  >
                </h4>
              </v-col>
            </v-row>
            <v-row
              align="center"
              :justify="$vuetify.breakpoint.name === 'xs' ? 'center' : 'start'"
              v-if="items.length"
            >
              <v-col
                cols="10"
                sm="6"
                md="4"
                lg="3"
                xl="3"
                v-for="(item, i) in computedItems"
                :key="i"
                class="pa-4"
              >
                <portal-card
                  :item="item"
                  :to="`/portals/${item.id}`"
                  @change="updatePortal(item)"
                >
                  <template v-slot:actions>
                    <v-switch
                      hide-details
                      class="my-0"
                      color="blue"
                      :true-value="1"
                      :false-value="0"
                      :label="item.active === 1 ? 'Active' : 'Paused'"
                      v-model="item.active"
                      @change="updatePortal(item)"
                    ></v-switch>
                    <v-spacer></v-spacer>
                    <v-menu offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>fa-ellipsis-h</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-action>
                            <v-icon>fa-desktop</v-icon>
                          </v-list-item-action>
                          <v-list-item-title class="font-weight-bold">
                            <v-text-field
                              label="Rename"
                              hide-details
                              denseflat
                              v-model="item.name"
                              @change="updatePortal(item)"
                            ></v-text-field>
                          </v-list-item-title>
                        </v-list-item>

                        <v-list-item :to="`/portals/${item.id}`">
                          <v-list-item-action>
                            <v-icon>fa-pencil-alt</v-icon>
                          </v-list-item-action>
                          <v-list-item-title class="font-weight-bold"
                            >Edit</v-list-item-title
                          >
                        </v-list-item>

                        <v-list-item @click="openSharing(item)">
                          <v-list-item-action>
                            <v-icon>fa-share</v-icon>
                          </v-list-item-action>
                          <v-list-item-title class="font-weight-bold"
                            >Share</v-list-item-title
                          >
                        </v-list-item>

                        <!-- <v-list-item :to="`/edit-services/${item.id}`">
                          <v-list-item-action>
                            <v-icon>fa-film</v-icon>
                          </v-list-item-action>
                          <v-list-item-title class="font-weight-bold">Request Edit</v-list-item-title>
                        </v-list-item>-->

                        <v-list-item @click="deletePortal(item)">
                          <v-list-item-action>
                            <v-icon>fa-trash</v-icon>
                          </v-list-item-action>
                          <v-list-item-title class="font-weight-bold"
                            >Delete</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </portal-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <v-bottom-sheet v-model="show_sharing" inset :max-width="500">
        <v-sheet>
          <portal-sharing
            @save="updatePortal(selected_portal)"
            v-model="selected_portal"
            :styles="$store.getters['membership'].style"
            @change="updatePortal(selected_portal)"
          ></portal-sharing>
        </v-sheet>
      </v-bottom-sheet>
      <v-bottom-sheet v-model="show_share_library" inset :max-width="500">
        <v-sheet>
          <share-portals
            v-if="show_share_library"
            :styles="$store.getters['membership'].style"
          ></share-portals>
        </v-sheet>
      </v-bottom-sheet>
    </v-container>
    <v-divider class="mt-4" v-if="items.length"></v-divider>

    <v-container class="py-0">
      <v-row justify="center">
        <v-col cols="12" lg="12" xl="9">
          <v-container class="pa-0">
            <v-row align="center" justify="center" class="mb-4">
              <v-col cols="12" md="4" lg="3" xl="3"></v-col>
              <v-col cols="12" md="4" lg="6" xl="6" class="text-center">
                <h2 class="secondary--text">Popular Templates</h2>
              </v-col>
              <v-col cols="10" sm="6" md="4" lg="3" xl="3">
                <v-select
                  label="Filer by"
                  v-model="template_filter"
                  hide-details
                  :items="['Event', 'Business']"
                  clearable
                ></v-select>
              </v-col>
            </v-row>
            <v-row
              :justify="$vuetify.breakpoint.name === 'xs' ? 'center' : 'start'"
            >
              <v-col
                cols="10"
                sm="6"
                md="4"
                lg="3"
                xl="3"
                v-for="(item, i) in filteredTemplates"
                class="pa-4"
                :key="i"
              >
                <portal-template :item="item"></portal-template>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import membershipBanner from "@/components/user/membership_banner";
import portalCard from "@/components/portal/previews/card";
import portalTemplate from "@/components/portal/previews/template";

import portalSharing from "@/components/portal/edit/sharing";
import sharePortals from "@/components/user/dialogs/share_portals";

export default {
  name: "UserPortals",
  components: {
    membershipBanner,
    portalCard,
    portalTemplate,
    portalSharing,
    sharePortals,
  },
  data() {
    return {
      selected_portal: null,
      show_settings: false,
      show_sharing: false,
      show_share_library: false,
      selected: [],
      deleting: false,
      loading: false,
      items: [],
      search: "",
      sort_by: "Newest",
      sort_options: ["Newest", "Oldest", "Applicants", "Visits"],
      alt: true,
      templates: [],
      template_filter: "",
      reload_timer: null,
    };
  },
  created() {
    if (this.$store.getters["trial_ended"]) {
      console.log("trial_ended");
      this.$eventBus.$emit("trial-ended");
    }
    if (localStorage.getItem("sort_by")) {
      if (this.sort_options.includes(localStorage.getItem("sort_by"))) {
        this.sort_by = localStorage.getItem("sort_by");
      }
    }
    this.load();
    // this.reload_timer = setInterval(this.autoRefresh, 15000);
  },
  beforeDestroy() {
    clearInterval(this.reload_timer);
  },
  watch: {
    sort_by: function () {
      this.sortItems(this.items);
      localStorage.setItem("sort_by", this.sort_by);
    },
  },
  computed: {
    computedItems() {
      if (this.search) {
        return this.items.filter(
          function (i) {
            if (
              i.name &&
              i.name.toLowerCase().includes(this.search.toLowerCase())
            ) {
              return true;
            }
            if (
              i.title &&
              i.title.toLowerCase().includes(this.search.toLowerCase())
            ) {
              return true;
            }
            return false;
          }.bind(this)
        );
      } else {
        return this.items;
      }
    },
    filteredTemplates() {
      return this.templates.filter(
        function (t) {
          if (this.template_filter) {
            return t.type === this.template_filter;
          } else {
            return true;
          }
        }.bind(this)
      );
    },
  },
  methods: {
    sharePortals() {
      this.show_share_library = true;
    },
    openSharing(item) {
      this.selected_portal = item;
      this.show_sharing = true;
    },
    openSettings(item) {
      this.selected_portal = item;
      this.show_settings = true;
    },
    autoRefresh() {
      if (!document.hidden) {
        this.load();
      }
    },
    sortItems(items) {
      items.sort(
        function (a, b) {
          if (this.sort_by === "Newest") {
            if (a.id > b.id) {
              return -1;
            } else {
              return 1;
            }
          } else if (this.sort_by === "Oldest") {
            if (a.id > b.id) {
              return 1;
            } else {
              return -1;
            }
          } else if (this.sort_by === "Applicants") {
            if (a.applicants > b.applicants) {
              return -1;
            } else {
              return 1;
            }
          } else if (this.sort_by === "Visits") {
            if (a.visits > b.visits) {
              return -1;
            } else {
              return 1;
            }
          } else {
            return 0;
          }
        }.bind(this)
      );
    },
    async deleteSelected() {
      if (!confirm(`Sure you want to delete all selected portals ?`)) {
        return;
      }
      this.deleting = true;
      try {
        await Promise.all(
          this.selected.map(
            function (id) {
              return this.$api.delete(`/user/portals/${id}`);
            }.bind(this)
          )
        );
        this.selected = [];
        await this.load();
        await this.$store.dispatch("countPortals");
      } catch (ex) {
        alert(ex.error);
      }
      this.deleting = false;
    },
    async updatePortal(item) {
      try {
        if (!item.name) {
          throw "Portal name required";
        }
        await this.$api.patch(`/user/portals/${item.id}`, item);
      } catch (ex) {
        alert(ex.error);
      }
    },
    async deletePortal(item) {
      if (!confirm(`Sure you want to delete "${item.name}" ?`)) {
        return;
      }
      await this.$api.delete(`/user/portals/${item.id}`);
      await this.load();
      await this.$store.dispatch("countPortals");
    },
    async load() {
      this.loading = true;
      try {
        let items = await this.$api(`/user/portals`);
        this.templates = await this.$api(`/templates`);
        this.sortItems(items);
        this.items = items;
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    },
  },
};
</script>

<style>
</style>